import { useState } from "react";
import { Bell } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useInboxUnreadCount, useInbox, useAckMatchesBatch } from "@/monitors/api";
import { BellDropdown } from "./BellDropdown";

export function BellButton() {
  const [open, setOpen] = useState(false);
  const { data: unreadCount = 0 } = useInboxUnreadCount();
  const inbox = useInbox({ stage: "confirmed", limit: 10 });
  const ackBatch = useAckMatchesBatch();

  const onOpenChange = (next: boolean) => {
    setOpen(next);
    if (next && inbox.data) {
      const unreadIds = inbox.data.matches
        .filter((m) => m.delivered_at === null)
        .map((m) => m.id);
      if (unreadIds.length > 0) ackBatch.mutate(unreadIds);
    }
  };

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="sm" className="relative" aria-label="Open matches inbox">
          <Bell className="h-4 w-4" />
          {unreadCount > 0 && (
            <Badge
              variant="default"
              className="absolute -top-1 -right-1 h-4 min-w-4 px-1 text-[10px] leading-none"
            >
              {unreadCount > 99 ? "99+" : unreadCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="p-0">
        <BellDropdown onClose={() => setOpen(false)} />
      </PopoverContent>
    </Popover>
  );
}
